// src/utils/ga.js

export const initGA = () => {
  if (window.gtag) return; // already initialized

  // Load GA script
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-BJ6HZXKWTP"; // Replace with your GA ID
  document.head.appendChild(script);

  // Initialize GA
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", "G-BJ6HZXKWTP"); // Replace with your GA ID
};

export const logPageView = (path) => {
  if (window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
    });
  }
};